import { useCallback, useState } from "react";

import { useTabGuardContext } from "../context";
import { KioskViewId } from "../types";

export const useKioskViewNavigation = () => {
    const { checkBeforeSwitch } = useTabGuardContext();
    const [currentView, setCurrentView] = useState<KioskViewId | null>(null);

    const navigateToView = useCallback(
        async (newView: KioskViewId | null) => {
            if (newView === currentView) return;

            const canSwitch = await checkBeforeSwitch(currentView, newView);
            if (canSwitch) {
                setCurrentView(newView);
            }
        },
        [currentView, checkBeforeSwitch]
    );

    const navigateToOverview = useCallback(() => {
        navigateToView(null);
    }, [navigateToView]);

    const handleCardClick = useCallback(
        (viewId: string) => {
            navigateToView(viewId as KioskViewId);
        },
        [navigateToView]
    );

    return {
        currentView,
        isOverview: currentView === null,
        navigateToView,
        navigateToOverview,
        handleCardClick,
    };
};
